import {grey} from '@mui/material/colors';
import {Link, Stack, Typography} from '@mui/material';

const FormHelperTextWithLink = ({
  text,
  onClick,
  isBusy,
  children,
  ...props
}) => {
  return (
    <Stack direction={'row'} justifyContent={'space-between'}>
      <Typography component={'p'} {...props}>
        {children}
      </Typography>

      <Link
        component="button"
        type={'button'}
        onClick={isBusy ? undefined : onClick}
        color={isBusy ? grey[600] : undefined}
        fontWeight={'bold'}>
        {text}
      </Link>
    </Stack>
  );
};

export default FormHelperTextWithLink;
